import { GROUP_TYPES as CONTAINER_TYPES } from '../'
import { ParsedContainers, ParsedHeader, ParsedCard, ParsedContainer } from '../definitions'

function isHeader(group: ParsedContainers): group is ParsedHeader {
  return group.type === CONTAINER_TYPES.header
}

function isCard(group: object): group is ParsedCard {
  return 'type' in group && group.type === CONTAINER_TYPES.card
}

function isContainer(group: object): group is ParsedContainer {
  return 'type' in group && group.type === CONTAINER_TYPES.container
}

function isReportContent(group: ParsedContainers): group is ParsedContainers {
  return isContainer(group) || isCard(group) || isHeader(group)
}

function isUnknownContainer(group: ParsedContainers): boolean {
  return !isHeader(group) && !isCard(group) && !isContainer(group)
}

export { isHeader, isCard, isContainer, isUnknownContainer, isReportContent }
